export const ADMIN_VERSION_STORAGE_KEY = "__extraconomy_admin_version";

export const ADMIN_VERSIONS = {
  CLASSIC: "classic",
  NEW: "new",
};

// A escolha fica vinculada ao token do login atual: depois de sair e entrar de novo
// (token novo), a tela de escolha volta a aparecer.
const currentToken = () => localStorage.getItem("__extraconomy_token") || "";

export const getStoredAdminVersion = () => {
  try {
    const stored = JSON.parse(localStorage.getItem(ADMIN_VERSION_STORAGE_KEY) || "null");
    if (!stored || stored.token !== currentToken()) return null;
    return Object.values(ADMIN_VERSIONS).includes(stored.version) ? stored.version : null;
  } catch (e) {
    // Valor antigo (string pura) ou storage indisponível: pede a escolha de novo
    return null;
  }
};

export const storeAdminVersion = (version) => {
  try {
    localStorage.setItem(
      ADMIN_VERSION_STORAGE_KEY,
      JSON.stringify({ version, token: currentToken() }),
    );
  } catch (e) {
    // Sem storage disponível a escolha vale só enquanto a página estiver aberta
  }
};
